import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { useGetActiveByLanguageQuery } from '../../../../__generated__/chirp/com/hubspot/academy/studio/rpc/services/AcademyStudioAnnouncementChirpService.hooks';
import getLang from '../../../utils/getLang';
export function useAnnouncements() {
  const currentLanguage = getLang().toUpperCase();
  const {
    data: announcementsData,
    error: announcementsError,
    loading
  } = useGetActiveByLanguageQuery({
    variables: {
      language: currentLanguage
    },
    errorPolicy: 'ignore'
  });
  const announcements = loading ? [] : announcementsData !== null && announcementsData !== void 0 && announcementsData.response ? [announcementsData.response] : [];
  const featuredAnnouncement = announcements[0];
  let featuredContentItems = [];
  if (featuredAnnouncement !== null && featuredAnnouncement !== void 0 && featuredAnnouncement.embeddedContent) {
    featuredContentItems = featuredAnnouncement === null || featuredAnnouncement === void 0 ? void 0 : featuredAnnouncement.embeddedContent.map(content => ({
      id: content.contentId,
      type: readUnhandledEnumCase(content.contentType),
      language: readUnhandledEnumCase(featuredAnnouncement.language)
    }));
  }
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: featuredContentItems,
    skip: !featuredContentItems.length
  });
  return {
    announcements,
    featuredCardModels: cardModels,
    loading: loading || cardModelsLoading,
    error: announcementsError || cardModelsError
  };
}